export const SUPPLIER_RETURNS_REQUEST = "SUPPLIER_RETURNS_REQUEST";
export const SUPPLIER_RETURNS_SUCCESS = "SUPPLIER_RETURNS_SUCCESS";
export const SUPPLIER_RETURNS_FAIL = "SUPPLIER_RETURNS_FAIL";

export const UPDATE_SUPPLIER_RETURN_REQUEST = "UPDATE_SUPPLIER_RETURN_REQUEST";
export const UPDATE_SUPPLIER_RETURN_SUCCESS = "UPDATE_SUPPLIER_RETURN_SUCCESS";
export const UPDATE_SUPPLIER_RETURN_FAIL = "UPDATE_SUPPLIER_RETURN_FAIL";

export const SUPPLIER_RETURN_RESET = "SUPPLIER_RETURN_RESET";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
